import React,{useContext,useEffect,useState} from 'react';
import './Preloader.css';
import SimpleContext from '../context/SimpleContext';





const Preloader = ({type}) => {
    const context = useContext(SimpleContext);
    
   
    const bgColor= context.theme.backgroundColor
    const dot = {
        margin: "auto",
        color:bgColor,
        width:"60px",
        height:'40px',
        "--d":'radial-gradient(farthest-side,currentColor 90%,#0000)',
        background:"var(--d),var(--d),var(--d)",
        backgroundSize:'20px 20px',
        backgroundRepeat:'no-repeat',
        animation:' m 1s infinite alternate',
    }
    // let returner ={} ;

    // if(context.AppType==="appGallery"){

    //     returner = 

    // }elseif(){

    // }elseif(){

    // }

    return ( 
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>  
     );
}
 
export default Preloader;